
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import MainLayout from "./layout/MainLayout";
import HomePage from "./pages/HomePage";
import About from "./pages/About";
import Serverices from "./pages/Serverices";
import Crm from "./features/Crm";
import BookDemo from "./pages/BookDemo";
import Erp from "./features/Erp";
import SaleManagement from "./features/SaleManagement";
import PayrollManagement from "./features/PayrollManagement";
import ServiceManagement from "./features/ServiceManagement";
import AMCManagement from "./features/AMCManagement";
import InventoryManagement from "./features/InventoryManagement";
import AccountingManagement from "./features/AccountingManagement";
import PricingPage from "./features/PricingPage";
import RegisterPage from "./pages/RegisterPage";
import { ToastContainer } from "react-toastify";
import SupportPage from "./pages/SupportPage";
import CustomerPage from "./pages/CustomerPage";
import Manufecturing from "./features/Manufecturing";
import ProductionPage from "./features/ProductionPage";
import ProcessManagementPage from "./features/ProcessManagementPage";
import ProjectManageMent from "./features/ProjectManageMent";
import AboutCompany from "./pages/AboutCompany";
import WhatsAppButton from "./layout/WhatsAppButton";
import AddBlog from "./pages/AddBlog";
import { HelmetProvider } from "react-helmet-async";
import BlogDetail from "./pages/BlogDetail";
import BlogDetailStandalone from "./pages/BlogDetailStandalone";
import Chatbot from "./chatbot/Chatbot";
import LoginPage from "./pages/LoginPage";
import Career from "./pages/Career";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ThankYouPage from "./pages/ThankYouPage";

// ================= APP CONTENT =================
const AppContent = () => {
  return (
    <>
      <Routes>

        {/* STANDALONE PAGES */}
        <Route
          path="/blog/:id"
          element={<BlogDetailStandalone />}
        />

        {/* MOBILE DEMO FORM */}
        <Route
          path="/book-demo-section/from1"
          element={<BookDemo minimalMobile />}
        />

        {/* MAIN LAYOUT */}
        <Route path="/" element={<MainLayout />}>

          {/* HOME */}
          <Route
            index
            element={<HomePage />}
          />

          {/* CAREER */}
          <Route
            path="/career"
            element={<Career />}
          />

          {/* AUTH */}
          <Route
            path="/register-page"
            element={<RegisterPage />}
          />

          <Route
            path="/login"
            element={<LoginPage />}
          />

          {/* ABOUT */}
          <Route
            path="/industories"
            element={<About />}
          />

          <Route
            path="/about-company"
            element={<AboutCompany />}
          />

          {/* SERVICES */}
          <Route
            path="/explore-our-services"
            element={<Serverices />}
          />

          <Route
            path="/crm-feature-section"
            element={<Crm />}
          />

          <Route
            path="/erp-feature-section"
            element={<Erp />}
          />

          <Route
            path="/sales-management"
            element={<SaleManagement />}
          />

          <Route
            path="/payroll-management"
            element={<PayrollManagement />}
          />

          <Route
            path="/services-mnagement"
            element={<ServiceManagement />}
          />

          <Route
            path="/cloud-solutions"
            element={<AMCManagement />}
          />

          <Route
            path="/inventory-management"
            element={<InventoryManagement />}
          />

          <Route
            path="/account-management"
            element={<AccountingManagement />}
          />

          {/* MANUFACTURING */}
          <Route
            path="/menufecturing-management"
            element={<Manufecturing />}
          />

          <Route
            path="/production"
            element={<ProductionPage />}
          />

          <Route
            path="/process-management"
            element={<ProcessManagementPage />}
          />

          <Route
            path="/project-management"
            element={<ProjectManageMent />}
          />

          {/* PRICING */}
          <Route
            path="/pricing"
            element={<PricingPage />}
          />

          {/* DEMO */}
          <Route
            path="/book-demo-section"
            element={<BookDemo />}
          />

          {/* SUPPORT */}
          <Route
            path="/support"
            element={<SupportPage />}
          />

          {/* PRIVACY */}
          <Route
            path="/privacy-policy"
            element={<PrivacyPolicy />}
          />

          {/* CUSTOMERS */}
          <Route
            path="/customers"
            element={<CustomerPage />}
          />

          {/* BLOG */}
          <Route
            path="/add-blog"
            element={<AddBlog />}
          />

        <Route path="/blog/:id" element={<BlogDetail />} />

          {/* CHATBOT */}
          <Route
            path="/chat-bot"
            element={<Chatbot />}
          />

          {/* THANK YOU */}
          <Route
            path="/thank-you"
            element={<ThankYouPage />}
          />

          {/* 404 */}
          <Route
            path="*"
            element={
              <div className="min-h-screen flex items-center justify-center text-3xl font-bold">
                Page Not Found
              </div>
            }
          />
        </Route>
      </Routes>

      {/* FLOATING WHATSAPP BUTTON */}
      <WhatsAppButton />
    </>
  );
};

// ================= APP =================
const App = () => {
  return (
    <HelmetProvider>
      <Router>

        {/* TOAST */}
        <ToastContainer
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="dark"
        />

        <AppContent />
      </Router>
    </HelmetProvider>
  );
};

export default App;

